import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from 'react';
import { handleDynamicCalltracking } from '@cian/frontend-dynamic-calltracking-component';

/**
 * DynamicPhone
 * @param {string} formattedPhone - fallback знычение для телефона
 * @param {number} siteBlockId - уникальное значение для получение телефона
 * @param {IHttpApi} httpApi - инстанс для выполения запроса
 * @param {ILogger} logger - инстанс для логгирования
 * @param {EPageTypes} pageType - тип страницы
 * @param {EPlatformTypes} platformType - тип платформы
 * @param {string} placeType - произвольная строка позволяющая однозначно определить кнопку на странице
 * @param {number} announcementId - id объявления
 * @param {string} queryString
 */
export var DynamicPhone = function DynamicPhone(_ref) {
  var formattedPhone = _ref.formattedPhone,
      siteBlockId = _ref.siteBlockId,
      httpApi = _ref.httpApi,
      logger = _ref.logger,
      placeType = _ref.placeType,
      pageType = _ref.pageType,
      platformType = _ref.platformType,
      announcementId = _ref.announcementId,
      queryString = _ref.queryString;

  var _React$useState = React.useState(formattedPhone),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      dynamicPhone = _React$useState2[0],
      setPhone = _React$useState2[1];

  var handleDynamicPhone = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$handleDynamicC, phone;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!siteBlockId) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return handleDynamicCalltracking({
              blockId: siteBlockId,
              platformType: platformType,
              pageType: pageType,
              placeType: placeType,
              httpApi: httpApi,
              logger: logger,
              announcementId: announcementId,
              queryString: queryString
            });

          case 4:
            _yield$handleDynamicC = _context.sent;
            phone = _yield$handleDynamicC.phone;

            if (phone) {
              setPhone(phone);
            }

          case 7:
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            logger.error(_context.t0, {
              domain: 'handleDynamicCalltracking'
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  })), [siteBlockId, placeType, queryString, announcementId]);
  React.useEffect(function () {
    handleDynamicPhone();
  }, [handleDynamicPhone]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, dynamicPhone);
};